import { useEffect } from 'react';

const FUNNEL_CLASS = 'sales-funnel-viewport-guard';

export default function useSalesFunnelViewportGuard() {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    html.classList.add(FUNNEL_CLASS);
    body.classList.add(FUNNEL_CLASS);

    return () => {
      html.classList.remove(FUNNEL_CLASS);
      body.classList.remove(FUNNEL_CLASS);
      html.classList.remove('sales-choose-boot');
      html.classList.remove('sales-choose-root');
      body.classList.remove('sales-choose-body');
    };
  }, []);
}
